export const CDN_BASE = 'https://noma-template.cdn.modulify.website'

export const img = (file: string): string => `${CDN_BASE}/images/${file}`
export const vid = (file: string): string => `${CDN_BASE}/video/${file}`

/* Client reviews live on this site's own storage, not the template host. */
const review = (name: string): string => `https://new-ss-site.cdn.modulify.website/images/testimonials/review-${name}.png`

/* The four frames the hero dissolves between, in slide order.
   Set by hand — do not swap these out. */
export const heroSlides = [
    { src: 'https://new-ss-site.cdn.modulify.website/images/hero-1.png', alt: 'A studio portrait in cobalt blue' },
    { src: 'https://new-ss-site.cdn.modulify.website/images/hero-2.png', alt: 'A studio portrait' },
    { src: 'https://new-ss-site.cdn.modulify.website/images/hero-3.png', alt: 'A studio portrait' },
    { src: 'https://new-ss-site.cdn.modulify.website/images/hero-4.png', alt: 'A studio portrait' }
]

export const media = {
    /* Background frame for each card in the home services accordion, in the
       same order as the services listed in the hero. */
    services: {
        marketing: 'https://new-ss-site.cdn.modulify.website/images/services/custom/service-marketing.png',
        aiImplementation: 'https://new-ss-site.cdn.modulify.website/images/services/custom/service-ai-implementation.png',
        aiAutomations: 'https://new-ss-site.cdn.modulify.website/images/services/custom/service-ai-automations.png',
        gtm: 'https://new-ss-site.cdn.modulify.website/images/services/custom/service-gtm.png',
        metaAds: 'https://new-ss-site.cdn.modulify.website/images/services/custom/service-meta-ads.png',
        googleAds: 'https://new-ss-site.cdn.modulify.website/images/services/custom/service-google-ads.png',
        webDesign: 'https://new-ss-site.cdn.modulify.website/images/services/custom/service-web-design.png',
        softwareDev: 'https://new-ss-site.cdn.modulify.website/images/services/custom/service-software-dev.png'
    },

    /* Client case photos, set by hand. StrongHer Lifts has none yet, so its
       records use an empty string and render the ink placeholder. */
    projects: {
        ironWarrior: {
            main: 'https://new-ss-site.cdn.modulify.website/images/projects/1-iron-warrior-main.jpg',
            extraOne: 'https://new-ss-site.cdn.modulify.website/images/projects/2-iron-warrior-extra-1.jpg',
            extraTwo: 'https://new-ss-site.cdn.modulify.website/images/projects/3-iron-warrior-extra-2.jpg'
        },
        strongher: {
            main: '/images/projects/strongher-lifts.png'
        },
        valhalla: {
            main: 'https://new-ss-site.cdn.modulify.website/images/projects/4-valhalla-main.jpg',
            extraOne: 'https://new-ss-site.cdn.modulify.website/images/projects/5-valhalla-extra-1.jpg',
            extraTwo: 'https://new-ss-site.cdn.modulify.website/images/projects/6-valhalla-extra-2.jpg'
        }
    },

    /* The old shared pool. Kept because the frames are still on the CDN, but
       nothing draws from it now that every project has its own two shots. */
    workPool: {
        product: img('work-product.jpg'),
        model: img('work-model.jpg'),
        material: img('work-material.jpg'),
        motion: img('work-motion.jpg')
    },

    people: {
        /* Set by hand on the about card — do not swap. */
        founderCard: img('about-founder-portrait.png'),
        aboutLogo: 'https://new-ss-site.cdn.modulify.website/images/strength-scaling-logo-v2.png',
        founderAvatar: img('team-jin.jpg'),
        avatarTwo: img('team-alex.jpg'),
        avatarThree: img('avatar-one.jpg'),
        contactPill: img('team-jin.jpg'),
        rating: [
            img('team-sarah.jpg'),
            img('team-alex.jpg'),
            img('avatar-one.jpg')
        ]
    },

    work: {
        /* The six client reviews behind the pinned zoom-out, in grid order.
           The zoom opens on index 1 from `sm` up and index 2 on a phone. Every card is a 1672 x 941 picture, so the alt
           text carries the review itself. Set by hand — do not swap these out. */
        reviews: [
            {
                src: review('ben-myers-dark'),
                alt: "Five-star review from Ben Myers: These guys rock!! Not only do they offer a game changing product for gym owners, they're also really good people who have your back. Highly recommend Strength Scaling to anyone in the fitness industry.",
                dark: true
            },
            {
                src: review('elson-gorica-dark'),
                alt: "Five-star review from Elson Gorica: Working with Strength Scaling has been a great experience. They're responsive, know their stuff when it comes to local ads and lead follow-up, and they explain everything clearly. You can tell they genuinely care about getting results for the businesses they work with. Highly recommend!",
                dark: true
            },
            {
                src: review('tanner-ellingsen-dark'),
                alt: "Five-star review from Tanner Ellingsen: Team is Top notch! They really know what they are doing and will really help your business grow. 5/5",
                dark: true
            },
            {
                src: review('karen-graham-dark'),
                alt: "Five-star review from Karen Graham: These guys are great! They genuinely care about helping you grow your business and want to provide the best possible support to help you meet your goals!",
                dark: true
            },
            {
                src: review('dylan-mcdonald-dark'),
                alt: "Five-star review from Dylan McDonald: Great people, with a track record of results!",
                dark: true
            },
            {
                src: review('ryan-anderson-dark'),
                alt: "Five-star review from Ryan Anderson: Peyton and Giuseppe have a genuine desire to help small businesses grow, which is evident through their entire process. I have met very few people in this space that rival their tenacity and drive to have successful outcomes with their clients. If ads or leads are your biggest trouble I would highly recommend reaching out to the team at Strength Scaling!",
                dark: true
            }
        ]
    },

    /* Editorial and studio frames used to break up the text-only sections. */
    editorial: {
        denim: img('editorial-denim.jpg'),
        silver: img('editorial-silver.jpg'),
        workspace: img('workspace-sketches.jpg'),
        texture: img('texture-leather.jpg'),
        interior: img('studio-interior.jpg'),
        catalogs: img('review-catalogs.jpg'),
        flatLay: img('flat-lay-tools.jpg'),
        /* Set by hand — do not swap. The moodboard sits in Principles and the
           book spread in Awards, both chosen against the cobalt. */
        moodboard: img('studio-moodboard.png'),
        bookSpread: img('studio-book-spread.png'),
        deskLight: img('studio-desk-light.png'),
        floorWide: img('studio-floor-wide.png')
    },

    clientPortraits: [
        img('portrait-client-one.jpg'),
        img('portrait-client-two.jpg'),
        img('portrait-client-three.jpg')
    ],

    callout: img('callout-texture.jpg'),
    /* The studio page shows all four of these at once, so each slot gets its
       own frame rather than repeating one across the section. */
    teamPhoto: img('studio-hero.jpg'),
    studioHero: img('studio-culture.jpg'),
    studioCulture: img('studio-interior.jpg'),
    studioWide: img('studio-wide.jpg'),

    video: {
        reelClip: vid('iZPuLK0vXt8CCy2noI8wC0FEz8.mp4'),
        motionClip: vid('w6hIDNoAdG3rSlPxSdrw8mLiU.mp4'),
        mosaicOne: vid('zk4QwPEBf55qHWWuzSLnDdW3k.mp4'),
        mosaicTwo: vid('C9XmxGlI7CHM3fP1IrUdFQc.mp4')
    }
}

/* Natural pixel size of each case photo, so a frame is never drawn wider than
   the photo can fill. A photo missing here is drawn at the frame's full size. */
export const photoSizes: Record<string, [number, number]> = {
    [media.projects.ironWarrior.main]: [1600, 1153],
    [media.projects.ironWarrior.extraOne]: [609, 704],
    [media.projects.ironWarrior.extraTwo]: [824, 825],
    [media.projects.strongher.main]: [1280, 1920],
    [media.projects.valhalla.main]: [1600, 900],
    [media.projects.valhalla.extraOne]: [680, 695],
    [media.projects.valhalla.extraTwo]: [517, 589]
}
